import { Application } from '@hotwired/stimulus';

import RichTextController from 'controllers/website/themes/elements/rich_text_controller';
import TextController from 'controllers/website/themes/elements/text_controller';
import TextareaController from 'controllers/website/themes/elements/textarea_controller';

import * as actions from 'apps/website/themes/inline_editor/helpers/actions';
import dispatchMessage from 'apps/website/themes/inline_editor/helpers/dispatchMessage';

import 'apps/website/themes/inline_editor/style.scss';

const application = Application.start();
application.register('rich-text-element', RichTextController);
application.register('text-element', TextController);
application.register('textarea-element', TextareaController);

let disableEditorOverlayTimeout: NodeJS.Timeout;

// Disables the editor overlay for a short period of time during undo/redo actions
const disableEditorOverlay = () => {
  if (disableEditorOverlayTimeout) {
    clearTimeout(disableEditorOverlayTimeout);
  }

  document.body.classList.add('disable-editor-overlay');

  disableEditorOverlayTimeout = setTimeout(() => {
    document.body.classList.remove('disable-editor-overlay');
  }, 500);
};

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('sage-excluded');
  document.body.classList.add('builder-inline-editor');
});

document.addEventListener('keydown', (event) => {
  // Emits undo/redo actions in the builder when pressing cmd+z or ctrl+z
  if ((event.metaKey || event.ctrlKey) && event.key === 'z') {
    dispatchMessage(event.shiftKey ? actions.redoEditing() : actions.undoEditing());
    disableEditorOverlay();
  }
});
